import { AppRouting } from '@core/enums';
import { ButtonType, NavigationLink } from '../models';

export const TOKEN_DATA_LOCALSTORAGE_KEY = 'tokenData';
export const CURRENT_MSISDN_LOCALSTORAGE_KEY = 'currentMsisdn';
export const ACTIVE_PRODUCT_LOCALSTORAGE_KEY = 'activeProduct';
export const FIRST_401_ERROR = 'first401Error';
export const REFRESH_IN_PROGRESS = 'refreshInProgress';
export const POPULATE_WIDGET_LIST =
  '[widgetList][on][widgets.faq-widget][populate][0]=faqList&populate[widgetList][on][widgets.link-widget][populate][0]=linkList&populate[widgetList][on][widgets.mini-banner-list-widget][populate][bannerList][populate][icon][fields][0]=url&populate[widgetList][on][widgets.mini-banner-list-widget][populate][bannerList][populate][backgroundImage][fields][0]=url&populate[widgetList][on][widgets.cloud-storage-widget][populate][primaryBackgroundImage][populate][fields][0]=url&populate[widgetList][on][widgets.cloud-storage-widget][populate][storageIcon][populate][fields][0]=url&populate[widgetList][on][widgets.mini-banner][populate][icon][populate][fields][0]=url&populate[widgetList][on][widgets.mini-banner][populate][backgroundImage][populate][fields][0]=url&populate[widgetList][on][widgets.mobile-app-widget][populate][primaryBackgroundImage][populate][fields][0]=url&populate[widgetList][on][widgets.mobile-app-widget][populate][standOutImage][populate][fields][0]=url';
export const POPULATE_FOOTER =
  '[copyright][populate]=*&populate[linkGroupList][populate][linkList][populate]=*&populate[contact][populate][contactList][populate][icon][populate][fields][0]=url';
export const LOCALE_LOCALSTORAGE_KEY = 'locale';
export const DEFAULT_LOCALE = 'en';
export const CONVERTED_PROFILE = 'convertedProfile';
export const ACTIVATION_CODE = 'activationCode';

const POPULATE_QUERY = {
  populate: {
    widgetList: {
      on: {
        'widgets.faq-widget': {
          populate: ['faqList'],
        },
        'widgets.link-widget': {
          populate: ['linkList'],
        },
        'widgets.mini-banner-list-widget': {
          populate: {
            bannerList: {
              populate: {
                icon: {
                  fields: ['url'],
                },
                backgroundImage: {
                  fields: ['url'],
                },
              },
            },
          },
        },
        'widgets.cloud-storage-widget': {
          populate: {
            primaryBackgroundImage: {
              populate: {
                fields: ['url'],
              },
            },
            storageIcon: {
              populate: {
                fields: ['url'],
              },
            },
          },
        },
        'widgets.mini-banner': {
          populate: {
            icon: {
              populate: {
                fields: ['url'],
              },
            },
            backgroundImage: {
              populate: {
                fields: ['url'],
              },
            },
          },
        },
        'widgets.mobile-app-widget': {
          populate: {
            primaryBackgroundImage: {
              populate: {
                fields: ['url'],
              },
            },
            standOutImage: {
              populate: {
                fields: ['url'],
              },
            },
          },
        },
      },
    },
  },
};

const FOOTER = {
  populate: {
    copyright: {
      populate: '*',
    },
    linkGroupList: {
      populate: {
        linkList: {
          populate: '*',
        },
      },
    },
    contact: {
      populate: {
        contactList: {
          populate: {
            icon: {
              populate: {
                fields: ['url'],
              },
            },
          },
        },
      },
    },
  },
};

export const ButtonClassMap: Record<ButtonType, string> = {
  [ButtonType.Black]:
    'h-10 rounded-full whitespace-nowrap flex items-center justify-center cursor-pointer text-mobileMd tablet:text-tabletMd desktop:text-desktopMd font-semibold tablet:font-semibold desktop:font-semibold w-full bg-black text-white',
  [ButtonType.Red]:
    'h-10 rounded-full whitespace-nowrap flex items-center justify-center cursor-pointer text-mobileMd tablet:text-tabletMd desktop:text-desktopMd font-semibold tablet:font-semibold desktop:font-semibold w-full bg-primaryRed text-white',
  [ButtonType.Border]:
    'h-10 rounded-full whitespace-nowrap flex items-center justify-center cursor-pointer text-mobileMd tablet:text-tabletMd desktop:text-desktopMd font-semibold tablet:font-semibold desktop:font-semibold w-full border border-black',
  [ButtonType.Text]:
    'flex items-center whitespace-nowrap justify-center cursor-pointer text-mobileMd tablet:text-tabletMd desktop:text-desktopMd font-semibold tablet:font-semibold desktop:font-semibold w-full',
  [ButtonType.Underline]:
    'h-10 rounded-full whitespace-nowrap flex items-center justify-center cursor-pointer text-mobileMd tablet:text-tabletMd desktop:text-desktopMd font-semibold tablet:font-semibold desktop:font-semibold w-full  underline-offset-2 underline',
  [ButtonType.White]:
    'h-10 rounded-full whitespace-nowrap flex items-center justify-center cursor-pointer  text-mobileMd tablet:text-tabletMd desktop:text-desktopMd font-semibold tablet:font-semibold desktop:font-semibold w-full bg-white',
  [ButtonType.Icon]: 'flex items-center justify-center cursor-pointer w-full',
};

export const ButtonPaddingCssClass = 'px-4 tablet:px-5 desktop:px-6';

export const PASSWORD_REGEX = {
  atLeastOneNumberRegex: /.*[0-9].*/,
  atLeastOneUppercaseRegex: /.*[A-Z].*/,
  atLeastOneLowercaseRegex: /.*[a-z].*/,
  atLeastOneSpecialCharacterRegex: /.*[!@#$].*/,
  atLeastEightCharactersRegex: /^.{8,}$/,
  atMostFiftyCharactersRegex: /^.{1,50}$/,
  latinCharactersRegex: /^[A-Za-zÀ-ÖØ-öø-ÿ0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/,
};

export const ADDRESS_REGEX = {
  validZipCodePattern: /^\d{4} ?[A-Z]{2}$/,
  validCityPattern: /^(?!-)(?!.*--)(?!.*-$)[A-Za-zÀ-ÖØ-öø-ÿă-ț\u2019' -]{2,}$/,
  validStreetNamePattern: /^(?!.*--)(?!.*\.\.\.)(?!-)(?!.*-$)[A-Za-zÀ-ÖØ-öø-ÿ0-9 .'\-\u2019\u2018]{2,}$/,
};

export const MAX_PASSWORD_LENGTH = 50;

export const REQUEST_DATE_FORMAT = 'MM-DD-YYYY';

export const linkNavigationList: NavigationLink[] = [
  {
    label: 'navigation.overview',
    path: `/${AppRouting.Overview}`,
    showWhenLimited: true,
    showWhenTerminated: true,
    icon: 'map-bold',
    subLinks: [],
  },
  {
    label: 'navigation.products',
    path: `/${AppRouting.Products}`,
    icon: 'calendar-bold',
    subLinks: [
      {
        label: 'navigation.usage',
        path: `/${AppRouting.Products}/${AppRouting.Usage}`,
        hideForInternet: true,
      },
      {
        label: 'navigation.topUp',
        path: `/${AppRouting.Products}/${AppRouting.TopUp}`,
        hideForB2B: true,
        hideForInternet: true,
      },
      {
        label: 'navigation.changeSubscription',
        path: `/${AppRouting.Products}/${AppRouting.ChangeSubscription}`,
        hideForB2B: true,
      },
      {
        label: 'navigation.dataOutsideEu',
        path: `/${AppRouting.Products}/${AppRouting.DataOutsideEu}`,
        hideForB2B: true,
        hideForInternet: true,
      },
      {
        label: 'navigation.premiumWallet',
        path: `/${AppRouting.Products}/${AppRouting.PremiumWallet}`,
        hideForB2B: true,
        hideForInternet: true,
      },
      // {
      //   label: 'navigation.addSubscription',
      //   path: `${AppRouting.Subscription}/${AppRouting.AddSubscription}`,
      // },
    ],
  },
  {
    label: 'navigation.invoices',
    path: `/${AppRouting.Invoices}`,
    showWhenLimited: true,
    showWhenTerminated: true,
    hideForB2B: true,
    icon: 'paper-bold',
    subLinks: [
      {
        label: 'navigation.paymentSettings',
        showWhenLimited: true,
        showWhenTerminated: true,
        path: `/${AppRouting.Invoices}/${AppRouting.PaymentSettings}`,
      },
    ],
  },
  {
    label: 'navigation.settings',
    path: `/${AppRouting.Settings}`,
    showWhenTerminated: false,
    hasActiveSubLinks: true,
    icon: 'settings-bold',
    subLinks: [
      {
        label: 'navigation.communicationAndPrivacy',
        path: `/${AppRouting.Settings}/${AppRouting.CommunicationAndPrivacy}`,
      },
      {
        label: 'navigation.simcardSettigns',
        path: `/${AppRouting.Settings}/${AppRouting.SimcardSettings}`,
        showWhenLimited: true,
        hideForInternet: true,
      },
      {
        label: 'navigation.networkSettings',
        path: `/${AppRouting.Settings}/${AppRouting.NetworkSettings}`,
        hideForDataOnly: true,
        hideForInternet: true,
      },
    ],
  },
  {
    label: 'navigation.cloudStorage',
    path: `/${AppRouting.CloudStorage}`,
    showWhenLimited: true,
    showWhenTerminated: true,
    showWhenJottaInUse: true,
    subLinks: [],
  },
];

const getNotLimited = (links: NavigationLink[]) => {
  return links
    .filter((l) => l.showWhenLimited || l.hasActiveSubLinks)
    .map((l) => ({
      ...l,
      subLinks: l.subLinks.filter((sl) => sl.showWhenLimited),
    }));
};

export const linkNavigationListLimited: NavigationLink[] = getNotLimited(linkNavigationList);

export function getLinkNavigationList(
  isLimited: boolean,
  isTerminated: boolean,
  isJottaInUse: boolean,
  isDataOnly: boolean,
  isB2B: boolean,
  isInternet: boolean,
): NavigationLink[] {
  let links = [...linkNavigationList];

  if (isLimited) {
    links = links
      .filter((link) => link.showWhenLimited || link.hasActiveSubLinks)
      .map((link) => ({
        ...link,
        subLinks: link.subLinks.filter((subLink) => subLink.showWhenLimited),
      }));
  }

  if (isTerminated) {
    links = links
      .filter((link) => link.showWhenTerminated)
      .map((link) => ({
        ...link,
        subLinks: link.subLinks.filter((subLink) => subLink.showWhenLimited),
      }));
  }

  if (!isJottaInUse) {
    links = links.filter((link) => !link.showWhenJottaInUse);
  }

  if (isDataOnly) {
    links = links.map((link) => ({
      ...link,
      subLinks: link.subLinks.filter((subLink) => !subLink.hideForDataOnly),
    }));
  }

  if (isB2B) {
    links = links
      .filter((link) => !link.hideForB2B)
      .map((link) => ({
        ...link,
        subLinks: link.subLinks.filter((subLink) => !subLink.hideForB2B),
      }));
  }

  if (isInternet) {
    links = links
      .filter((link) => !link.hideForInternet)
      .map((link) => ({
        ...link,
        subLinks: link.subLinks.filter((subLink) => !subLink.hideForInternet),
      }));
  }


  return links;
}
